module.exports = __webpack_public_path__ + "static/media/Footer_cogir_foundation.6e6f8cef.png";